import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, text, align = "left", light = false, className = "" }) => (
  <Reveal className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`}>
    {eyebrow && <div className="eyebrow">{eyebrow}</div>}
    <h2 className={`mt-4 text-3xl font-semibold leading-[1.1] sm:text-4xl lg:text-5xl ${light ? "text-navy" : "text-white"}`}>{title}</h2>
    {text && <p className={`mt-6 text-base leading-relaxed md:text-lg ${light ? "text-slate-600" : "text-slate-400"}`}>{text}</p>}
  </Reveal>
);
